import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
export var useInView = function useInView(target) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isIntersecting = _useState2[0],
    setIsIntersecting = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    observer = _useState4[0],
    setObserver = _useState4[1];
  useEffect(function () {
    var handleIntersect = function handleIntersect(entries) {
      setIsIntersecting(entries[0].isIntersecting);
    };
    observer === null || observer === void 0 || observer.disconnect();
    if (target.current) {
      var _observer = new IntersectionObserver(handleIntersect, options);
      _observer.observe(target.current);
      setObserver(_observer);
    }
  }, [target.current, options.root, options.rootMargin, options.threshold]); // eslint-disable-line

  useEffect(function () {
    return function () {
      observer === null || observer === void 0 || observer.disconnect();
    };
  }, []); // eslint-disable-line

  return isIntersecting;
};